import ImagePreviewModel from "crop-image/src/ImagePreviewModel";
import { mapToCropRequest } from "@/frameworks/imagePreviewModelMapper";
import BackgroundFileAddRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFileAddRequest";
import BackgroundFileGetDetailResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/BackgroundFilesService/BackgroundFileGetDetailResponse";
import NatureSoundTranslateViewModel from "./natureSoundTranslateViewModel";
import AudioFileBaseModel from "@models/audioFileBaseModel";
// import MeditationAudioViewModel from "@models/meditations/create/meditationAudioViewModel";

export default class CreateNatureSoundViewModel {
    id: string = '';
	animationId: string = null;
	animationUrl: string = null;
	translations: Array<NatureSoundTranslateViewModel> = [];
	coverImage: ImagePreviewModel = new ImagePreviewModel();
	backgroundImage: ImagePreviewModel = new ImagePreviewModel();
	audio: AudioFileBaseModel = new AudioFileBaseModel();
	toServerModel(): BackgroundFileAddRequest {
		const req = new BackgroundFileAddRequest({
			Id: this.id,
			AnimationId: this.animationId,
			BackImage: mapToCropRequest(this.backgroundImage), // this.coverImage,
			CoverImage: mapToCropRequest(this.coverImage), // this.coverImage,
			Translations: (this.translations || []).map(x=>x.toServerModel()),
			Base64Content: this.audio.base64File || null
		});
		return req;
	}
	initLanguages(langs: string[]) {
		this.translations = langs.map(x=>new NatureSoundTranslateViewModel({
			langCode: x
		}));
	}
	fromServerModel(model: BackgroundFileGetDetailResponse) {
		this.id = model.Id;
		this.backgroundImage.ImageUrl = model.BackUrl;
		this.coverImage.ImageUrl = model.CoverUrl;		
		this.audio.audioUrl = model.AudioFileUrl;
		this.animationId = model.AnimationId;

		this.translations.forEach(tr => {
			const serverTranslation = model.Translations.find(x=>x.LangCode == tr.langCode);
			if (serverTranslation != null) {
				tr.name = serverTranslation.Name;
				tr.id = serverTranslation.Id;
			}
		});
	}
}
